import AddSchoolsTotalPrice from './AddSchoolsTotalPrice.component';

export default AddSchoolsTotalPrice;